import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClipboard, FiSearch, FiFileText, FiActivity, FiCheckCircle } = FiIcons;

const TreatmentProcess = () => {
  const steps = [
    {
      icon: FiClipboard,
      title: 'Assessment',
      description: 'Initial consultation to understand your history and goals.'
    },
    {
      icon: FiSearch,
      title: 'Diagnosis',
      description: 'Thorough physical examination to identify the root cause.'
    },
    {
      icon: FiFileText,
      title: 'Personalized Plan',
      description: 'Creating a tailored treatment roadmap just for you.'
    },
    {
      icon: FiActivity,
      title: 'Therapy Sessions',
      description: 'Hands-on treatment and guided exercises.'
    },
    {
      icon: FiCheckCircle,
      title: 'Recovery',
      description: 'Final evaluation and maintenance plan for long-term health.'
    }
  ];

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-emerald-600 font-semibold text-sm tracking-wider uppercase mb-2 block">How We Work</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Your Path to Recovery
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Our structured approach ensures you receive the most effective care at every stage of your healing journey.
          </p>
        </motion.div>

        <div className="relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-slate-200 -translate-y-1/2 z-0 mx-16"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 relative z-10">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.15 }}
                className="flex flex-col items-center text-center bg-white p-4"
              >
                <div className="w-16 h-16 bg-white border-4 border-emerald-100 rounded-full flex items-center justify-center mb-4 shadow-sm relative">
                  <span className="absolute -top-2 -right-2 w-6 h-6 bg-emerald-600 text-white text-xs font-bold rounded-full flex items-center justify-center">
                    {index + 1}
                  </span>
                  <SafeIcon icon={step.icon} className="w-7 h-7 text-emerald-600" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{step.title}</h3>
                <p className="text-sm text-slate-600">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentProcess;